// RÉ-ÉDITION — thème Shopify

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileNav();
  initReveal();
  initFilters();
  initProductVariants();
});

function initHeader(){
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function initMobileNav(){
  const toggle = document.querySelector('.nav-toggle');
  const menu = document.querySelector('.nav-mobile');
  const header = document.querySelector('.site-header');
  if (!toggle || !menu) return;
  const setOpen = (open) => {
    menu.classList.toggle('is-open', open);
    toggle.classList.toggle('is-active', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (header) header.classList.toggle('menu-open', open);
  };
  toggle.addEventListener('click', () => setOpen(!menu.classList.contains('is-open')));
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setOpen(false)));
}

function initReveal(){
  const items = document.querySelectorAll('.reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)){
    items.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting){
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  items.forEach(el => io.observe(el));
}

// filtres de la page Collection (par type de produit)
function initFilters(){
  const filters = document.querySelectorAll('.filter-btn');
  const cards = document.querySelectorAll('.product-card');
  if (!filters.length || !cards.length) return;
  filters.forEach(btn => {
    btn.addEventListener('click', () => {
      filters.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const cat = btn.dataset.filter;
      cards.forEach(card => {
        const match = cat === 'tout' || card.dataset.category === cat;
        card.classList.toggle('is-hidden', !match);
      });
    });
  });
}

// page produit : miniatures + sélection de variante
function initProductVariants(){
  const form = document.getElementById('product-form');
  if (!form) return;

  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('product-main-image');
  thumbs.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbs.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (mainImg) mainImg.src = btn.dataset.full;
    });
  });

  const selects = document.querySelectorAll('.product-option-select');
  const variantIdInput = document.getElementById('product-variant-id');
  const variantsJsonEl = document.getElementById('product-variants-json');
  const priceEl = document.querySelector('.product-price');
  const addBtn = document.querySelector('.product-add-btn');
  if (!selects.length || !variantsJsonEl) return;

  let variants = [];
  try { variants = JSON.parse(variantsJsonEl.textContent); } catch (e) { variants = []; }

  function currentOptions(){
    return Array.from(selects).map(s => s.value);
  }

  function findVariant(options){
    return variants.find(v => {
      const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
      return options.every((val, i) => vOpts[i] === val);
    });
  }

  function money(cents){
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  selects.forEach(select => {
    select.addEventListener('change', () => {
      const variant = findVariant(currentOptions());
      if (!variant) return;
      variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Rupture de stock';
      }
    });
  });
}
